export const CONTENT_TITLES = {
  list: '店舗一覧',
  detail: '店舗詳細',
}
export const REGIONS = {
  北海道: ['北海道'],
  東北: ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
  関東: ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '神奈川県'],
  東京: ['東京都'],
  '北陸/甲信越': ['新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県'],
  東海: ['岐阜県', '静岡県', '愛知県', '三重県'],
  関西: ['滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
  '中国/四国': [
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
  ],
  '九州/沖縄': [
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
  ],
}

export const BRANDS = [
  'Francfranc',
  'Francfranc BAZAR',
  'Francfranc SELECT',
  'アインズ＆トルペ SHOPinSHOP',
]

export const BRAND_ALIASES = {
  'Francfranc BEAUTY SELECT': 'Francfranc SELECT',
}

export const normalizeBrand = (brand) => BRAND_ALIASES[brand] || brand

export const PARAMS_VALIDATORS = {
  brand: (v) => BRANDS.includes(normalizeBrand(v)),
  prefecture: (v) => Object.values(REGIONS).flat().includes(v),
  store: (v) => /^\d{1,3}$/.test(v),
  region: (v) => Object.keys(REGIONS).includes(v),
  q: (v) => typeof v === 'string' && v.length > 0,
}

/**
 * 都道府県名から地域名へのマッピングオブジェクト。
 * 例: PREF_TO_REGION['青森県'] === '東北'
 * @type {Object.<string, string>}
 */
export const PREF_TO_REGION = Object.entries(REGIONS).reduce(
  (acc, [region, prefs]) => {
    prefs.forEach((pref) => {
      acc[pref] = region
    })
    return acc
  },
  {}
)
